import { Component, Input } from "@angular/core";
import { Proposal } from "../../../../../../../../models/new-product/base/proposal.model";
import * as Enums from "../../../../../../../../framework/enum.shared";
import { KeyValue } from "../../../../../../../../framework/domain-entity/key-value";
import { common } from "../../../../../../../../../app/framework/utils/common";
import { pageLifeCycleNotifier } from "../../../../../../../../../app/models/new-product/notifier/page-life-cycle-notifier";
import { MfHkBaseComponent } from "../../mf-hk-base.component";
import { MortgageFireHongKongProposal } from "src/app/models/new-product/sme/mortgage-fire/hong-kong/base/mf-hk-proposal";
import { MfHKProposalService } from "src/app/services/new-product/sme/mortgage-fire/hong-kong/mf-hk-proposal.service";

@Component({
    selector: "mf-hk-referral-validation-echo-panel",
    templateUrl: "./mf-hk-referral-validation-echo-panel.component.html",
    styleUrls: ["./mf-hk-referral-validation-echo-panel.component.scss"],
    standalone: false
})
export class MfHkReferralValidationEchoPanelComponent extends MfHkBaseComponent {
  pageLoaded: boolean = false;
  proposal!: MortgageFireHongKongProposal;
  isIncomplete: boolean = false;
  isReferred: boolean = false;
  isPendingChecker: boolean = false;
  showBusinessRulesManager: boolean = false;

  constructor(public proposalService: MfHKProposalService) {
    super();
  }

  ngOnDestroy = () => {
    super.unsubscribeRxjs();
  };

  override ngOnInit(): void {
    super.subscribeProposalLoadedNotifier((event) => {
      this.proposal = event.value as MortgageFireHongKongProposal;
      this.showBusinessRulesManager = this.checkBusinessRulesManager();
      this.pageLoaded = true;
      this.isIncomplete =
        this.proposal.proposalStatus === Enums.ProposalStatus.Incomplete
          ? true
          : false;
      this.isReferred =
        this.proposal.proposalStatus === Enums.ProposalStatus.Referred
          ? true
          : false;
      this.isPendingChecker =
        this.proposal.proposalStatus === Enums.ProposalStatus.PendingChecker
          ? true
          : false;
    });
    super.subscribeProposalSavedNotifier(this.proposalLoaded);
  }

  private proposalLoaded = (event: KeyValue<Proposal>) => {
    this.proposal = event.value as MortgageFireHongKongProposal;
    this.showBusinessRulesManager = this.checkBusinessRulesManager();
    this.isIncomplete =
      this.proposal.proposalStatus === Enums.ProposalStatus.Incomplete
        ? true
        : false;
    this.isReferred =
      this.proposal.proposalStatus === Enums.ProposalStatus.Referred
        ? true
        : false;
    this.isPendingChecker =
      this.proposal.proposalStatus === Enums.ProposalStatus.PendingChecker
        ? true
        : false;
  };

  checkBusinessRulesManager() {
    let flag: boolean = false;
    if (
      common.isDefined(this.proposalService.businessRulesManager) &&
      common.isDefined(this.proposalService.businessRulesManager.echos)
    ) {
      return this.proposalService.businessRulesManager.echos.length > 0
        ? true
        : false;
    }
    return flag;
  }

  initialize() {}

  navigate(question: any) {
    pageLifeCycleNotifier.tab_request_notifier$.next(
      new KeyValue(question.tabId.toString(), question.key)
    );
  }
}
